import { useState, useEffect } from "react";

export default function useElementEdgeCenters(ref) {
  const [edges, setEdges] = useState({ left: null, right: null });

  useEffect(() => {
    if (!ref.current) return;

    const update = () => {
      if (!ref.current) return;
      const rect = ref.current.getBoundingClientRect();

      const left = {
        x: rect.left,
        y: rect.top + rect.height / 2,
      };

      const right = {
        x: rect.right,
        y: rect.top + rect.height / 2,
      };

      setEdges({ left, right });
    };

    // Observe element resize
    const resizeObserver = new ResizeObserver(update);
    resizeObserver.observe(ref.current);

    // Listen for window changes
    window.addEventListener("resize", update);
    window.addEventListener("scroll", update, true);
    window.addEventListener("click", update);

    update();

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", update);
      window.removeEventListener("scroll", update, true);
      window.addEventListener("click", update);
    };
  }, [ref]);

  return edges;
}